import {showAlert} from '../../redux/reducers/alertSlice'
import {addLanguage} from '../../redux/reducers/languageSlice'
import {useDispatch} from 'react-redux'
import {addCohort} from '../../redux/reducers/cohortSlice'
import {useNavigate} from 'react-router-dom'
import {addUnit} from '../../redux/reducers/unitSlice'
import axios from 'axios'
import api from '../../../_metronic/helpers/api'
import {stringify} from 'qs'
import { addSeason } from '../../redux/reducers/seasonSlice'
function useUtils() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleEdit = async (id) => {
    try {
      const response = await api.get(
        `/module/${id}?relations[]=cohort&relations[]=language&relations[]=moduleUnit.unit&relations[]=tag`,
        {}
      )
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const uploadImage = async (values) => {
    try {
      const uniqueFileName = `file_${Date.now()}`
      const imageFile = values.image
      const fileType = imageFile.type
      const fileSize = `${imageFile.size}px`

      const uploadDetails = {
        fileName: uniqueFileName,
        fileType: fileType,
        size: fileSize,
      }

      console.log(uploadDetails)

      const uploadResponse = await api.post('s3/upload-url', uploadDetails)

      const {mediaId, signedUrl} = uploadResponse.data.data

      console.log(mediaId, signedUrl)
      const imageUploadResponse = await axios.put(signedUrl, imageFile, {
        headers: {
          'Content-Type': fileType,
        },
      })

      if (imageUploadResponse.status !== 200) {
        throw new Error('Image upload failed')
      }

      const data = {
        code: values?.code,
        title: values.title,
        authorName: values.authorName,
        cohortId: values.cohortId,
        languageId: values.languageId,
        mediaId,
        description: values.description,
        unitIds: values.unitIds,
        tags: values.tags,
        status: 'drafts',
      }

      publishModule(data)
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const editImage = async (id, values) => {
    try {
      const uniqueFileName = `file_${Date.now()}`
      const imageFile = values.image
      const fileType = imageFile.type
      const fileSize = `${imageFile.size}px`

      const uploadDetails = {
        fileName: uniqueFileName,
        fileType: fileType,
        size: fileSize,
      }

      console.log(uploadDetails)

      const uploadResponse = await api.post('s3/upload-url', uploadDetails)

      const {mediaId, signedUrl} = uploadResponse.data.data

      console.log(mediaId, signedUrl)
      const imageUploadResponse = await axios.put(signedUrl, imageFile, {
        headers: {
          'Content-Type': fileType,
        },
      })

      if (imageUploadResponse.status !== 200) {
        throw new Error('Image upload failed')
      }

      const data = {
        code: values?.code,
        title: values.title,
        authorName: values.authorName,
        cohortId: values.cohortId,
        languageId: values.languageId,
        mediaId,
        description: values.description,
        unitIds: values.unitIds,
        tags: values.tags,
        status: 'drafts',
      }
      console.log(data)
      try {
        const response = await api.patch(`/module/${id}`, data)
        if (response?.data?.status) {
          dispatch(showAlert({message: 'Successfully Updated', variant: 'success'}))
          navigate('/modulelist')
        }
      } catch (error) {
        dispatch(
          showAlert({
            message: error?.response?.data?.message,
            variant: 'danger',
          })
        )
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const publishModule = async (data) => {
    try {
      const response = await api.post(`/module`, data)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Successfully added', variant: 'success'}))
        navigate('/modulelist')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const editModule = async (id, data) => {
    try {
      const response = await api.patch(`/module/${id}`, data)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Successfully Updated', variant: 'success'}))
        navigate('/modulelist')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const deleteModule = async (id, limit, offset) => {
    try {
      const response = await api.delete(`/module/${id}`)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Module deleted', variant: 'success'}))
        return fetchModules(null, null, null,null, limit, offset)
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const fetchModules = async (
    text = null,
    status = null,
    cohortId = null,
    seasonId = null,
    limit = 10,
    offset = 0
  ) => {
    const params = {
      limit,
      offset,
      relations: ['tag', 'cohort'],
      where: {},
    }
    if (text) {
      params.text = text
    }

    if (status && status !== 'Status') {
      params.where.status = status
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }
    if (seasonId && seasonId !== 'Season') {
      params.where.seasonId = seasonId
    }

    try {
      const response = await api.get(`/module?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Something went wrong',
          variant: 'danger',
        })
      )
    }
  }

  const fetchLanguages = async () => {
    try {
      const response = await api.get(
        `/language?select[id]=true&select[name]=true&select[createdAt]=true&order[name]=ASC`,
        {
          params: {
            returnAllRecords: true,
            offset: 0,
          },
        }
      )
      if (response.data.status) {
        dispatch(addLanguage(response.data.data))
      }
    } catch (error) {}
  }

  const fetchCohorts = async () => {
    try {
      const response = await api.get(
        `/cohort?select[id]=true&select[title]=true&select[createdAt]=true&order[title]=ASC`,
        {
          params: {
            returnAllRecords: true,
            offset: 0,
          },
        }
      )
      if (response.data.status) {
        dispatch(addCohort(response.data.data))
      }
    } catch (error) {}
  }
  const fetchUnits = async (languageId) => {
    try {
      const params = {
        returnAllRecords: true,
        where: {},
      }

      if (languageId ) {
        params.where.languageId = languageId
      }

      const response = await api.get(`/unit?${stringify(params)}`)
  
      if (response.data.status) {
        dispatch(addUnit(response.data.data))
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const fetchSeasons = async () => {
    const params = {
      returnAllRecords: true,
      offset: 0,
    }

    try {
      const response = await api.get(
        `/season?${stringify(params)}&select[id]=true&select[name]=true&order[name]=ASC`
      )
      if (response.data.status) {
        dispatch(addSeason(response.data.data))
      }
    } catch (error) {
      console.log(error?.message)
    }
  }

  const fetchAllModules = async (text = null,
    status = null,
    cohortId = null,
    seasonId = null,) => {
    const params = {
      limit: 100,
      offset: 0,
      order: {createdAt: 'DESC'},
      relations: ['tag', 'moduleUnit'],
      where: {},
    }
    if (text) {
      params.text = text
    }

    if (status && status !== 'Status') {
      params.where.status = status
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }
    if (seasonId && seasonId !== 'Season') {
      params.where.seasonId = seasonId
    }
    let allData = []
    let totalRecords = 0
    try {
      const initialResponse = await api.get(`/module?${stringify(params)}`)
      if (initialResponse.data.status) {
        totalRecords = initialResponse.data.data.count
        allData = initialResponse.data.data.records

        const totalChunks = Math.ceil(totalRecords / params.limit)
        const promises = []

        for (let i = 1; i < totalChunks; i++) {
          params.offset = i * params.limit
          promises.push(api.get(`/module?${stringify(params)}`))
        }

        const responses = await Promise.all(promises)
        responses.forEach((response) => {
          if (response.data.status) {
            allData = [...allData, ...response.data.data.records]
          }
        })

        if (allData?.length > 0) {
          return allData?.map((module) => ({
            id: module?.id,
            code: module?.code || '',
            title: module?.title || '',
            authorName: module.authorName || '',
            cohort: module?.cohortId || null,
            language: module?.languageId || null,
            description: module?.description || '',
            season: module?.seasonId,
            ForBlackforceMember: module?.isForBlackforceMember || false,
            units: module?.moduleUnit?.map((unit) => unit?.unitId).filter(Boolean),
            tags: module?.tag ? module?.tag?.map((tag) => tag?.name) : [],
          }))
        }
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Something went wrong',
          variant: 'danger',
        })
      )
    }
  }

  const addCSV = async (data) => {
    try {
      const response = await api.post(`/module/add-bulk`, data)
      if (response?.data?.status) {
        return response?.data?.data
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const submitReport = async(data) =>{
    try {
      const response = await api.post(
        `/setting/sendCSVReport`, data)
       return response
    } catch (error) {
      
    }
  }

  return {
    addCSV,
    fetchSeasons,
    editImage,
    fetchAllModules,
    uploadImage,
    handleEdit,
    editModule,
    publishModule,
    fetchUnits,
    deleteModule,
    fetchCohorts,
    fetchLanguages,
    fetchModules,
    submitReport
  }
}

export default useUtils
